import useDisplayNames from '../useDisplayNames'
import pluralize from 'pluralize'

const useActivitiesDisplayName = () => {
    const { getDisplayName } = useDisplayNames()

    const plural = getDisplayName('activities', 'Activities')
    const singular = pluralize.singular(plural)

    return { singular, plural }
}

export default useActivitiesDisplayName
